import { useTranslation } from "@emisgroup/acp-application-intl";
import { Button } from "@emisgroup/ui-button";
import React, { useEffect, useMemo } from "react";
import { RuleDetailsContainer } from "@emisgroup/query-builder-library";
import { useDispatch } from "react-redux";
import { Environments } from "@emisgroup/cohort-builder-kit";
import { resetCode, setCode } from "../../redux/Slice";
import { useUser } from "../../../../../AuthContext";
import { FEASIBILITY_APP_ID } from "../../../../LeftPanel/Constant";
import { memoryCache } from "../../../../../service/services/memory-cache.service";
import ChevronLeft from "~icons/ic/outline-chevron-left";

interface RulesProps {
  executionName: string;
  executionId: string;
  artefactId: string;
  hasOptOutElement?: boolean;
  onBack: () => void;
}

export const Rules: React.FC<RulesProps> = ({
  onBack,
  executionId,
  executionName,
  artefactId,
  hasOptOutElement = false
}) => {
  const { t: translate } = useTranslation();
  const dispatch = useDispatch();
  const reportArtefactId = sessionStorage.getItem("selectedReportArtefactId");
  const actualArtefactId = reportArtefactId || artefactId;
  const { user } = useUser();
  const token = user.token;

  const handleCodeDetails = (codeListId: string, codeListName: string, queryName: string): void => {
    dispatch(
      setCode(
        {
          executionId,
          codeListId,
          codeListName,
          ruleName: queryName,
          artefactId: actualArtefactId
        }
      )
    );
  };

  useEffect(() => {
    return () => {
      memoryCache.clear("entitySelection");
      dispatch(resetCode());

      if (!reportArtefactId) {
        return
      }

      sessionStorage.removeItem("selectedReportArtefactId");
    };
  }, []);

  // NOTE(I.G): Because we don't have access to the search name from the backend,
  //            We are getting it from the DOM based on the selected tab.
  const searchName = useMemo(() => {
    if (hasOptOutElement) {
      return sessionStorage.getItem("selectedReportArtefactName") || "";
    }

    return (document.querySelector(
      '.qms-extract-tab div[role="tablist"] button[aria-selected="true"]'
    ) as HTMLElement)?.title || "";
  }, [hasOptOutElement]);

  return (
    <>
      <Button onClick={(): void => { onBack(); }} data-testid="backButton">
        <ChevronLeft title="back"/>
        {translate("ResultDetails.CodeList.Back")}
      </Button>
      <div className="result-list__code_view__rules_header">
        <h3>{executionName}</h3>
        <p>{translate("ResultDetails.CodeList.SearchDiagnosis")}: {searchName}</p>
      </div>
      <RuleDetailsContainer
        artefactId={actualArtefactId}
        env={process.env.APP_TARGET_ENV as Environments}
        token={token}
        applicationId={FEASIBILITY_APP_ID}
        getSelectedCodeDetails={handleCodeDetails}
      />
    </>
  );
};
